module.exports = __webpack_public_path__ + "img/ic_32_sport_tischtennis-white.1c3f86eb.svg";